import api from 'api/api'
import { toast } from "react-toastify"

import { API_URL } from 'constants/index'


export const GET_LIST_MENUS = "[MENU CONTROL] GET LIST MENU CONTROL"

export const GET_LIST_MENUS_PADRES = "[MENU CONTROL] GET LIST MENU PADRES"

export const GET_LIST_MENUS_HIJOS = "[MENU CONTROL] GET LIST MENU HIJOS"

export const CRUD_MENU = "[MENU CONTROL] CRUD MENU CONTROL"

export function getMenuControl() {
  const request = api.get(`/menu`)

  return (dispatch) =>
    request.then((response) => {
      dispatch({ type: GET_LIST_MENUS, payload: response.data.detalles === null ? [] : response.data.detalles, })
    })
}

export function getMenuPadres() {
  const request = api.get(`/menupadres`)
  return (dispatch) =>
    request.then((response) => {
      return dispatch({
        type: GET_LIST_MENUS_PADRES,
        payload: response.data.detalles === null ? [] : response.data.detalles,
      })
    })
}

export function getMenus() {
  const request = api.get(`/menus`)
  return (dispatch) =>
    request.then((response) => {
      return dispatch({
        type: GET_LIST_MENUS_HIJOS,
        payload: response.data.detalles === null ? [] : response.data.detalles,
      })
    })
}

export function saveMenu(form) {
  const request = api.post(`/rmenu`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_MENU, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_MENU, payload: { loading: false, crud: true } })
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      setTimeout(() => {
        dispatch({ type: CRUD_MENU, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_MENU, payload: { loading: false, crud: false } })
      toast.error("Error al crear el menu")
      console.log(error)
    })
  }
}

export function updateMenu(form) {
  const request = api.post(`/amenu`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_MENU, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_MENU, payload: { loading: false, crud: true } })
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      setTimeout(() => {
        dispatch({ type: CRUD_MENU, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_MENU, payload: { loading: false, crud: false } })
      toast.error("Error al actualizar el menu")
      console.log(error)
    })
  }
}

export function deleteMenu(form) {
  const request = api.post(`/emenu`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_MENU, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_MENU, payload: { loading: false, crud: true } })
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      setTimeout(() => {
        dispatch({ type: CRUD_MENU, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_MENU, payload: { loading: false, crud: false } })
      toast.error("Error al eliminar el menu")
      console.log(error)
    })
  }
}
